import Button from "components/Button";
import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";

export const OptionNameSection = styled.div`
    position: relative;
`;

export const OptionIcon = styled.img`
    width: 14px;
    height: 14px;
    position: absolute;
    left: -22px;
    top: 2px;
`;

export const OptionName = styled(Text)`
    letter-spacing: 0.245em;
    font-weight: 600;
    color: ${theme.colors.grey.dark};
`;

export const PriceSection = styled.div`
    display: flex;
    position: relative;
`;

export const Price = styled(Text)`
    font-weight: 700;
    font-size: 60px;
    line-height: 73px;
    color: ${theme.colors.purple.primary};
`;

export const DollarSign = styled.span`
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    align-self: flex-start;
    color: ${theme.colors.purple.primary};
    position: absolute;
    top: 9px;
    left: -50px;
`;

export const Per = styled(Text)`
    align-self: flex-end;
    color: ${theme.colors.grey.secondary};
    position: absolute;
    bottom: 14px;
    right: -25px;
  
`;

export const PriceText = styled(Text)`
    font-weight: 500;
    color: ${theme.colors.grey.dark};
`;

export const FeaturesSection = styled.div`
    width: 100%;
    border-top: 1px solid #8868EA;
    padding: 6px 3px;
    padding-bottom: 25px;
    &:hover {
     color: ${theme.colors.white}
    }
`;

export const Feature = styled.div`
    display: flex;
    align-items: center;
    color: ${theme.colors.grey.primary};
    margin-top: 18px;
    gap: 10px;
    
`;

export const FeatureText = styled(Text)``;

export const FeatureBoldText = styled(Text)`
    color: ${theme.colors.grey.dark};
`;

export const ChooseButton = styled(Button)`
    margin-top: auto;
    margin-bottom: 20px;
`;

export const FeatureIcon = styled.div`
color: '#8868EA'
`
export const PricingOptionWrapper = styled.div`
    background-color: #fff;
    border-radius: 40px;
    background-color: #fff;
    padding: 24px 36px;
    display: flex;
    flex-direction: column;
    
    align-items: center;
    border: 1px solid ${theme.colors.purple.secondary};
    max-width: 300px;
    row-gap: 25px;
    min-height: 600px;
    &:hover {
        background-color: ${theme.colors.purple.primary};
        ${OptionName}, ${Per},${PriceText},${FeatureBoldText},${Feature}, ${Price}, ${DollarSign} {
            color: #fff;
        }
            ${ChooseButton}{
                      background-color:${theme.colors.white};
                      color: ${theme.colors.purple.secondary}
    
            }
                      ${FeatureIcon} {
                        color: #fff;
                      }
                      ${FeaturesSection}{
                        border-top-color: ${theme.colors.white}
                      }
    }

    @media only screen and (max-width: 925px) {
        border-radius: 25px;
    }
`;


export const ProPricingCard = styled.div`
   border: 1px solid ${theme.colors.white};
   border-radius: 14px;
   padding: 6px;
   position: relative;
   top:-2.5rem; 
   background-color: ${theme.colors.purple.primary};
   color:${theme.colors.white};
`